import { produce } from 'immer';
import * as z from 'zod';

export const reportParsingError = (error: unknown) => {
  if (window?.Sentry) {
    window.Sentry.captureException(
      new Error('Encountered an error trying to parse user config', {
        cause: error instanceof z.ZodError ? error.format() : error,
      })
    );
  } else {
    // oxlint-disable-next-line no-console
    console.error(error);
  }
};

export const updateWithSchema = <T extends z.ZodTypeAny>(
  schema: T,
  value: unknown,
  updater: (draft: z.infer<T>) => void
) => {
  try {
    const parsed = schema.parse(value);

    return produce(parsed, updater);
  } catch (e) {
    reportParsingError(e);
    return value;
  }
};
